import { setGoToUrl } from '@chengla_web/cl_newutil'
import { getDomainContext } from '../common/js/domainRuntime'

const { isLocal } = getDomainContext()

// api根路径
export const API_ROOT = isLocal
  ? process.env.API_ROOT
  : setGoToUrl('u.api', process.env.VUE_APP_ENV)



// WEBPACK FOOTER //
// ./src/util/config.js